import api from '@/utils/httpClient';
import serviceUrls from '@oncolens/oncolens-ui/lib/api/service-urls';
import { useQuery, UseQueryOptions } from 'react-query';

const apiBase = serviceUrls.AUTH.BASE();

function introspect() {
  return api.get(`${apiBase}/auth/introspect`).then((response: any) => {
    return response?.data as IntrospectUserResponse;
  });
}

export function useIntrospect(options?: UseQueryOptions<IntrospectUserResponse>) {
  return useQuery('introspect', () => introspect(), {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    ...options
  });
}

export interface IntrospectUserResponse {
	user: string;
	domainUser: DomainUser;
	legacyUserDetails: LegacyUserDetails;
}

export interface LegacyUserDetails {
	associatedHospitalUUIDs: string[];
	email: string;
	externalPracticeID: string;
	id: string;
	impersonator: string;
	primaryHospitalUUID: string;
	specialityID: string;
	userUsesWrapper: boolean;
}

export interface DomainUser {
	id: string;
	email: string;
	orgRoles: OrgRole[];
}

export interface OrgRole {
	organizationId: string;
	orgName: string;
	role: string;
}
